"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledQuantity = exports.StyledLabel = exports.StyledInput = exports.StyledButtonContainer = exports.StyledButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "Quantitystyles__StyledLabel",
  componentId: "sc-1p8oszu-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    db w-100 pb2\n  ", "\n  "])), function (_ref) {
  var label = _ref.theme.textInput.label;
  return "".concat(label);
}));

exports.StyledLabel = StyledLabel;

var StyledButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "Quantitystyles__StyledButtonContainer",
  componentId: "sc-1p8oszu-1"
})(["width:40px;flex-shrink:0;"]);

exports.StyledButtonContainer = StyledButtonContainer;

var StyledQuantity = _styledComponents["default"].div.withConfig({
  displayName: "Quantitystyles__StyledQuantity",
  componentId: "sc-1p8oszu-2"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    ba inline-flex overflow-hidden\n  ", "\n  "])), function (_ref2) {
  var _ref2$theme$quantity = _ref2.theme.quantity,
      backgroundColor = _ref2$theme$quantity.backgroundColor,
      borderColor = _ref2$theme$quantity.borderColor,
      borderRadius = _ref2$theme$quantity.borderRadius,
      borderWeight = _ref2$theme$quantity.borderWeight;
  return "".concat(backgroundColor, " ").concat(borderColor, " ").concat(borderRadius, " ").concat(borderWeight);
}));

exports.StyledQuantity = StyledQuantity;

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "Quantitystyles__StyledButton",
  componentId: "sc-1p8oszu-3"
})(["", " &:disabled{cursor:not-allowed;", "}&:hover,&:focus,&:active{outline:none;}"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    bn flex items-center justify-center pointer w-100 h-100 f3\n  ", "\n  "])), function (_ref3) {
  var backgroundColor = _ref3.theme.quantity.backgroundColor;
  return "".concat(backgroundColor);
}), (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["bg-mid-gray"]))));

exports.StyledButton = StyledButton;

var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "Quantitystyles__StyledInput",
  componentId: "sc-1p8oszu-4"
})(["::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}-moz-appearance:textfield;min-width:40px;", " &:hover,&:focus,&:active{outline:none;}", " ", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    tc bn bl br f5 lh-solid w-100 ma0 pa0\n  ", "\n  "])), function (_ref4) {
  var maxLength = _ref4.maxLength,
      _ref4$theme$quantity = _ref4.theme.quantity,
      backgroundColor = _ref4$theme$quantity.backgroundColor,
      borderColor = _ref4$theme$quantity.borderColor;
  return "\n    ".concat(backgroundColor, " ").concat(borderColor, "\n    ").concat(maxLength > 2 && 'ph1', "\n  ");
}), (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref5) {
  var warning = _ref5.warning;
  return warning && 'orange';
}), function (_ref6) {
  var warning = _ref6.warning;
  return warning && "border-bottom: 3px solid var(--orange);";
});

exports.StyledInput = StyledInput;